import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useHistory, useLocation as useRouterLocation } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import Header from "../header/header";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config.json";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const SESSION_KEY = "audit_answer_page_v4";

const injectStyles = () => {
    if (document.getElementById("aap-styles-v5")) return;
    const s = document.createElement("style");
    s.id = "aap-styles-v5";
    s.textContent = `
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600&display=swap');
        .aap-wrap { --aap-font:'Plus Jakarta Sans',sans-serif; --aap-mono:'JetBrains Mono',monospace; --aap-bg:#eef0f6; --aap-ink:#0e1726; --aap-ink2:#374151; --aap-ink3:#6b7280; --aap-ink4:#9ca3af; --aap-line:#e5e7eb; --aap-line2:#f3f4f6; --aap-blue:#2563eb; --aap-blue2:#eff6ff; --aap-blue3:#dbeafe; --aap-teal:#0d9488; --aap-teal2:#f0fdfa; --aap-teal3:#ccfbf1; --aap-red:#dc2626; --aap-red2:#fff1f2; --aap-red3:#fecdd3; --aap-gold:#d97706; --aap-gold2:#fffbeb; --aap-gold3:#fde68a; --aap-purple:#7c3aed; --aap-purple2:#f5f3ff; --aap-purple3:#ddd6fe; }
        .aap-wrap *, .aap-wrap *::before, .aap-wrap *::after { box-sizing: border-box; }
        .aap-wrap .aap-tr { transition: background .1s; border-bottom: 2px solid var(--aap-bg); }
        .aap-wrap .aap-tr-odd-pending   { background: #ffffff; }
        .aap-wrap .aap-tr-even-pending  { background: #f7f9ff; }
        .aap-wrap .aap-tr-odd-approved  { background: #f0fdfa; }
        .aap-wrap .aap-tr-even-approved { background: #e6fbf7; }
        .aap-wrap .aap-tr-odd-rejected  { background: #fff8f8; }
        .aap-wrap .aap-tr-even-rejected { background: #fff0f0; }
        .aap-wrap .aap-tr-odd-inreview  { background: #fffbeb; }
        .aap-wrap .aap-tr-even-inreview { background: #fff6d6; }
        .aap-wrap .aap-tr:hover { filter: brightness(.965); }
        .aap-wrap .aap-cb { width: 14px; height: 14px; accent-color: var(--aap-blue); cursor: pointer; }
        @keyframes aapShimV5 { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
        .aap-wrap .aap-shimmer { background: linear-gradient(90deg,#edf0f5 25%,#f7f8fb 50%,#edf0f5 75%); background-size: 1200px 100%; border-radius: 5px; animation: aapShimV5 1.6s infinite linear; }
        @keyframes aapSpinV5 { to { transform: rotate(360deg); } }
        .aap-wrap .aap-spin { display: inline-block; width: 11px; height: 11px; flex-shrink: 0; border-radius: 50%; border: 2px solid transparent; animation: aapSpinV5 .65s linear infinite; }
        .aap-wrap .btn-approve { display: inline-flex; align-items: center; justify-content: center; gap: 5px; padding: 7px 16px; border-radius: 8px; border: none; background: linear-gradient(135deg,#0d9488,#0f766e); color: #fff; font-size: 12px; font-weight: 700; cursor: pointer; font-family: var(--aap-font); letter-spacing: .01em; transition: transform .1s, box-shadow .12s; box-shadow: 0 2px 8px rgba(13,148,136,.35); }
        .aap-wrap .btn-approve:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 4px 14px rgba(13,148,136,.42); }
        .aap-wrap .btn-approve:active:not(:disabled) { transform: translateY(0); }
        .aap-wrap .btn-approve:disabled { opacity:.45; cursor:not-allowed; box-shadow:none; transform:none; }
        .aap-wrap .btn-reject { display: inline-flex; align-items: center; justify-content: center; gap: 5px; padding: 7px 14px; border-radius: 8px; border: 1.5px solid var(--aap-red3); background: var(--aap-red2); color: var(--aap-red); font-size: 12px; font-weight: 700; cursor: pointer; font-family: var(--aap-font); letter-spacing: .01em; transition: transform .1s, background .12s, box-shadow .12s; }
        .aap-wrap .btn-reject:hover:not(:disabled) { background: var(--aap-red3); transform: translateY(-1px); box-shadow: 0 3px 10px rgba(220,38,38,.18); }
        .aap-wrap .btn-reject:active:not(:disabled) { transform: translateY(0); }
        .aap-wrap .btn-reject:disabled { opacity:.45; cursor:not-allowed; transform:none; }
        .aap-wrap .btn-sec { display: inline-flex; align-items: center; gap: 5px; padding: 6px 13px; border-radius: 7px; border: 1px solid var(--aap-line); background: var(--aap-line2); color: var(--aap-ink3); font-size: 11.5px; font-weight: 600; cursor: pointer; font-family: var(--aap-font); transition: background .1s; }
        .aap-wrap .btn-sec:hover { background: var(--aap-line); }
        .aap-wrap .btn-approve-all { display: inline-flex; align-items: center; gap: 7px; padding: 9px 20px; border-radius: 9px; border: none; background: linear-gradient(135deg,#0d9488,#0f766e); color: #fff; font-size: 12px; font-weight: 700; cursor: pointer; font-family: var(--aap-font); letter-spacing: .01em; transition: transform .1s, box-shadow .12s; box-shadow: 0 2px 10px rgba(13,148,136,.32); }
        .aap-wrap .btn-approve-all:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 5px 16px rgba(13,148,136,.38); }
        .aap-wrap .btn-approve-all:disabled { opacity:.5; cursor:not-allowed; transform:none; box-shadow:none; }
        .aap-wrap .btn-bulk-ok { display: inline-flex; align-items: center; gap: 5px; padding: 5px 14px; border-radius: 7px; border: none; background: var(--aap-teal); color: #fff; font-size: 11px; font-weight: 700; cursor: pointer; font-family: var(--aap-font); transition: opacity .12s; box-shadow: 0 1px 4px rgba(13,148,136,.25); }
        .aap-wrap .btn-bulk-ok:hover:not(:disabled) { opacity: .88; }
        .aap-wrap .btn-bulk-ok:disabled { opacity:.5; cursor:not-allowed; }
        .aap-wrap .aap-sel { height: 34px; padding: 0 10px; border-radius: 8px; border: 1.5px solid var(--aap-line); background: #fff; color: var(--aap-ink2); font-size: 12px; font-weight: 500; font-family: var(--aap-font); outline: none; cursor: pointer; }
        .aap-wrap .aap-sel:focus { border-color: var(--aap-blue); }
        .aap-wrap .aap-sel.on { border-color: var(--aap-blue); background: var(--aap-blue2); color: var(--aap-blue); font-weight: 700; }
        @keyframes aapToastV5 { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:none} }
        .aap-wrap .aap-toast { animation: aapToastV5 .2s ease; }
        .aap-wrap .aap-reject-panel { padding: 14px 20px 16px 56px; background: linear-gradient(135deg,#fff5f5,#fff8f8); border-top: 1px dashed var(--aap-red3); border-bottom: 1px solid var(--aap-red3); }
        .aap-wrap .aap-chip { display: inline-flex; align-items: center; gap: 5px; padding: 3px 10px; border-radius: 20px; font-size: 10.5px; font-weight: 700; white-space: nowrap; font-family: var(--aap-font); }
        .aap-wrap .aap-type-badge { display: inline-flex; align-items: center; padding: 1px 6px; border-radius: 4px; font-size: 8.5px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; font-family: var(--aap-mono); flex-shrink: 0; }
        .aap-wrap .aap-action-chip { display: inline-flex; align-items: center; gap: 6px; padding: 5px 12px; border-radius: 8px; font-size: 11px; font-weight: 700; font-family: var(--aap-font); white-space: nowrap; }
        .aap-wrap .aap-await-chip { display: inline-flex; align-items: center; gap: 6px; padding: 5px 11px; border-radius: 8px; border: 1.5px solid var(--aap-line); background: var(--aap-line2); color: var(--aap-ink3); font-size: 10.5px; font-weight: 600; font-family: var(--aap-font); }
        .aap-wrap .aap-na-chip { display: inline-flex; align-items: center; gap: 5px; padding: 4px 10px; border-radius: 8px; border: 1.5px solid var(--aap-line); background: var(--aap-line2); color: var(--aap-ink4); font-size: 10px; font-weight: 600; font-family: var(--aap-font); }
        .aap-wrap .aap-my-status { display: inline-flex; align-items: center; gap: 4px; padding: 2px 7px; border-radius: 20px; font-size: 9.5px; font-weight: 700; font-family: var(--aap-font); white-space: nowrap; margin-top: 5px; }
        .aap-wrap .aap-user-sel { height: 34px; padding: 0 10px; border-radius: 8px; border: 1.5px solid var(--aap-line); background: #fff; color: var(--aap-ink2); font-size: 12px; font-weight: 500; font-family: var(--aap-font); outline: none; cursor: pointer; max-width: 180px; }
        .aap-wrap .aap-user-sel:focus { border-color: var(--aap-blue); }
        .aap-wrap .aap-user-sel.on { border-color: var(--aap-blue); background: var(--aap-blue2); color: var(--aap-blue); font-weight: 700; }
        /* Chain node */
        .aap-wrap .aap-chain-node { display: inline-flex; align-items: center; gap: 4px; padding: 2px 7px; border-radius: 20px; font-size: 9px; font-weight: 700; white-space: nowrap; }
    `;
    document.head.appendChild(s);
};

const fmtDate = (d) => {
    if (!d) return "—";
    try { return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
    catch { return d; }
};

const AV_COLORS = ["#2563eb", "#0d9488", "#dc2626", "#d97706", "#7c3aed", "#0891b2", "#be185d", "#0f766e"];
const Avatar = ({ name = "", id, size = 27 }) => {
    const p = (name || "").split(" ");
    const ini = [(p[0]?.[0] || ""), (p[1]?.[0] || "")].join("").toUpperCase() || "?";
    return (
        <div style={{ width: size, height: size, borderRadius: "50%", background: AV_COLORS[Number(id || 0) % AV_COLORS.length], color: "#fff", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * .33, fontWeight: 700, fontFamily: "var(--aap-mono)" }}>
            {ini}
        </div>
    );
};

const Stat = ({ label, value, color, bg, border }) => (
    <div style={{ padding: "9px 16px", borderRadius: 10, background: bg, border: `1.5px solid ${border}`, minWidth: 86, textAlign: "center", fontFamily: "var(--aap-font)" }}>
        <div style={{ fontSize: 9, fontWeight: 700, color, textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 3 }}>{label}</div>
        <div style={{ fontSize: 22, fontWeight: 800, color, fontFamily: "var(--aap-mono)", lineHeight: 1 }}>{value}</div>
    </div>
);

const SC = {
    APPROVED: { bg: "#f0fdfa", border: "#99f6e4", color: "#0d9488", label: "Approved" },
    ACCEPTED: { bg: "#f0fdfa", border: "#99f6e4", color: "#0d9488", label: "Approved" },
    REJECTED: { bg: "#fff1f2", border: "#fecdd3", color: "#dc2626", label: "Rejected" },
    PENDING:  { bg: "#fffbeb", border: "#fde68a", color: "#d97706", label: "Pending" },
    IN_REVIEW:{ bg: "#eff6ff", border: "#bfdbfe", color: "#2563eb", label: "In Review" },
    WAITING:  { bg: "#f8fafc", border: "#e2e8f0", color: "#94a3b8", label: "Waiting" },
};

const Badge = ({ status }) => {
    const c = SC[(status || "PENDING").toUpperCase()] || SC.PENDING;
    return (
        <span className="aap-chip" style={{ background: c.bg, border: `1.5px solid ${c.border}`, color: c.color }}>
            <span style={{ width: 5, height: 5, borderRadius: "50%", background: c.color, flexShrink: 0 }} />
            {c.label}
        </span>
    );
};

const TypeBadge = ({ type }) => {
    const isExt = (type || "").toUpperCase() === "EXTERNAL";
    return (
        <span className="aap-type-badge" style={{ background: isExt ? "var(--aap-purple2)" : "var(--aap-blue2)", color: isExt ? "var(--aap-purple)" : "var(--aap-blue)", border: `1px solid ${isExt ? "var(--aap-purple3)" : "var(--aap-blue3)"}` }}>
            {isExt ? "EXT" : "INT"}
        </span>
    );
};

const CHAIN_SC = {
    APPROVED: { color: "#0d9488", bg: "#f0fdfa", border: "#99f6e4", dot: "✓" },
    ACCEPTED: { color: "#0d9488", bg: "#f0fdfa", border: "#99f6e4", dot: "✓" },
    REJECTED: { color: "#dc2626", bg: "#fff1f2", border: "#fecdd3", dot: "✕" },
    PENDING:  { color: "#d97706", bg: "#fffbeb", border: "#fde68a", dot: "◉" },
    WAITING:  { color: "#94a3b8", bg: "#f8fafc", border: "#e2e8f0", dot: "○" },
};

const AuditChainFlow = ({ auditLevels = [] }) => {
    if (!auditLevels.length) return null;
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap", marginTop: 9, paddingTop: 8, borderTop: "1px dashed var(--aap-line)" }}>
            {auditLevels.map((lvl, i) => {
                const sc = CHAIN_SC[(lvl.status || "WAITING").toUpperCase()] || CHAIN_SC.WAITING;
                return (
                    <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
                        <span
                            className="aap-chain-node"
                            style={{ background: sc.bg, color: sc.color, border: `1px solid ${sc.border}` }}
                            title={`${lvl.auditorType} Level ${lvl.auditLevel}${lvl.auditorName ? ` — ${lvl.auditorName}` : ""}`}
                        >
                            <TypeBadge type={lvl.auditorType} />
                            <span style={{ fontFamily: "var(--aap-mono)", fontSize: 8.5 }}>L{lvl.auditLevel}</span>
                            <span style={{ maxWidth: 64, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 9 }}>
                                {(lvl.auditorName || "").split(" ")[0]}
                            </span>
                            <span style={{ fontSize: 9 }}>{sc.dot}</span>
                        </span>
                        {i < auditLevels.length - 1 && (
                            <span style={{ color: "#cbd5e1", fontSize: 8, flexShrink: 0 }}>→</span>
                        )}
                    </span>
                );
            })}
        </div>
    );
};

const resolveMyEntry = (auditLevels = [], currentUserId) => {
    // eslint-disable-next-line eqeqeq
    return auditLevels.find(l => l.auditorId == currentUserId) || null;
};

const prevLevelsAllApproved = (auditLevels = [], myEntry) => {
    if (!myEntry) return false;
    const myType = (myEntry.auditorType || "").toUpperCase();
    const toCheck = myType === "EXTERNAL"
        ? auditLevels.filter(l =>
            (l.auditorType || "").toUpperCase() === "INTERNAL" ||
            ((l.auditorType || "").toUpperCase() === "EXTERNAL" && l.auditLevel < myEntry.auditLevel)
          )
        : auditLevels.filter(l =>
            (l.auditorType || "").toUpperCase() === "INTERNAL" &&
            l.auditLevel < myEntry.auditLevel
          );
    return toCheck.every(l => ["APPROVED", "ACCEPTED"].includes((l.status || "").toUpperCase()));
};

const FilterBar = ({ fromDate, toDate, fyId, statusFilter, userFilter, fys, userOptions, onFromDate, onToDate, onFyId, onStatusFilter, onUserFilter, onClear, hasFilters, displayedCount, totalCount, loading }) => (
    <div style={{ display: "flex", gap: 7, alignItems: "center", flexWrap: "wrap", paddingBottom: 14 }}>
        <div style={{ display: "flex", alignItems: "stretch", border: "1.5px solid var(--aap-line)", borderRadius: 8, overflow: "hidden", background: "#fff", height: 34 }}>
            <span style={{ display: "flex", alignItems: "center", padding: "0 9px", fontSize: 9.5, color: "var(--aap-ink4)", fontWeight: 700, borderRight: "1px solid var(--aap-line)", textTransform: "uppercase", letterSpacing: ".06em", fontFamily: "var(--aap-font)", whiteSpace: "nowrap" }}>From</span>
            <input type="date" value={fromDate} onChange={e => onFromDate(e.target.value)} style={{ border: "none", outline: "none", padding: "0 9px", fontSize: 12, color: "var(--aap-ink)", background: "transparent", height: "100%", fontFamily: "var(--aap-font)" }} />
        </div>
        <div style={{ display: "flex", alignItems: "stretch", border: "1.5px solid var(--aap-line)", borderRadius: 8, overflow: "hidden", background: "#fff", height: 34 }}>
            <span style={{ display: "flex", alignItems: "center", padding: "0 9px", fontSize: 9.5, color: "var(--aap-ink4)", fontWeight: 700, borderRight: "1px solid var(--aap-line)", textTransform: "uppercase", letterSpacing: ".06em", fontFamily: "var(--aap-font)", whiteSpace: "nowrap" }}>To</span>
            <input type="date" value={toDate} min={fromDate} onChange={e => onToDate(e.target.value)} style={{ border: "none", outline: "none", padding: "0 9px", fontSize: 12, color: "var(--aap-ink)", background: "transparent", height: "100%", fontFamily: "var(--aap-font)" }} />
        </div>
        <select className="aap-sel" value={fyId} onChange={e => onFyId(e.target.value)}>
            <option value="">All Financial Years</option>
            {fys.map(f => <option key={f.id} value={String(f.id)}>{f.financial_year_value || f.name}</option>)}
        </select>
        <select className={`aap-sel${statusFilter ? " on" : ""}`} value={statusFilter} onChange={e => onStatusFilter(e.target.value)}>
            <option value="">All Statuses</option>
            <option value="PENDING">Pending</option>
            <option value="APPROVED">Approved</option>
            <option value="REJECTED">Rejected</option>
        </select>
        <select className={`aap-user-sel${userFilter ? " on" : ""}`} value={userFilter} onChange={e => onUserFilter(e.target.value)}>
            <option value="">All Users</option>
            {userOptions.map(u => <option key={u.id} value={String(u.id)}>{u.name}</option>)}
        </select>
        {hasFilters && <button onClick={onClear} style={{ fontSize: 11, color: "var(--aap-red)", background: "var(--aap-red2)", border: "1.5px solid var(--aap-red3)", borderRadius: 20, padding: "4px 12px", cursor: "pointer", fontWeight: 700, fontFamily: "var(--aap-font)" }}>× clear</button>}
        <div style={{ flex: 1 }} />
        {!loading && <span style={{ fontSize: 11, color: "var(--aap-ink4)", fontFamily: "var(--aap-mono)" }}>{displayedCount} / {totalCount}</span>}
    </div>
);

const DocModal = ({ info, onClose }) => {
    const { url, name, mimeType, isImage } = info;
    const isPdf = /pdf/i.test(mimeType || "") || /\.pdf(\?|$)/i.test(url || "");
    useEffect(() => { const h = e => { if (e.key === "Escape") onClose(); }; document.addEventListener("keydown", h); return () => document.removeEventListener("keydown", h); }, [onClose]);
    return (
        <div onClick={e => { if (e.target === e.currentTarget) onClose(); }} style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(14,23,38,.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, backdropFilter: "blur(4px)" }}>
            <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 880, maxHeight: "92vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 32px 80px rgba(0,0,0,.22)", fontFamily: "var(--aap-font)" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "13px 18px", borderBottom: "1px solid #e5e7eb", flexShrink: 0, gap: 12 }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#0e1726", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
                    <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                        <a href={url} target="_blank" rel="noreferrer" style={{ padding: "5px 13px", borderRadius: 7, border: "1.5px solid #e5e7eb", background: "#f3f4f6", color: "#374151", fontSize: 11.5, fontWeight: 600, textDecoration: "none" }}>Open in tab</a>
                        <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: 7, border: "1.5px solid #e5e7eb", background: "transparent", cursor: "pointer", fontSize: 18, color: "#6b7280", lineHeight: 1 }}>×</button>
                    </div>
                </div>
                <div style={{ flex: 1, overflow: "auto", padding: 20, background: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center", minHeight: 260 }}>
                    {isImage && <img src={url} alt={name} style={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: 8, boxShadow: "0 6px 24px rgba(0,0,0,.14)" }} />}
                    {isPdf && <iframe src={url} title={name} style={{ width: "100%", height: "70vh", border: "none", borderRadius: 8 }} />}
                    {!isImage && !isPdf && <div style={{ textAlign: "center", padding: 48 }}><div style={{ fontSize: 36, opacity: .22, marginBottom: 12 }}>📄</div><div style={{ fontWeight: 700, color: "#374151", marginBottom: 10 }}>Preview unavailable</div><a href={url} target="_blank" rel="noreferrer" style={{ padding: "7px 16px", borderRadius: 8, background: "#2563eb", color: "#fff", fontSize: 12, fontWeight: 700, textDecoration: "none" }}>Download / Open</a></div>}
                </div>
            </div>
        </div>
    );
};

const BulkRejectModal = ({ count, onConfirm, onCancel, saving }) => {
    const [note, setNote] = useState("");
    return (
        <div onClick={e => { if (e.target === e.currentTarget) onCancel(); }} style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(14,23,38,.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, backdropFilter: "blur(4px)" }}>
            <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 460, boxShadow: "0 20px 60px rgba(0,0,0,.16)", fontFamily: "var(--aap-font)" }}>
                <div style={{ padding: "16px 20px", borderBottom: "1px solid #e5e7eb" }}>
                    <div style={{ fontSize: 15, fontWeight: 800, color: "#0e1726", marginBottom: 2 }}>Reject {count} Answer{count !== 1 ? "s" : ""}</div>
                    <div style={{ fontSize: 12, color: "#9ca3af" }}>This reason will apply to all selected answers.</div>
                </div>
                <div style={{ padding: "16px 20px" }}>
                    <label style={{ display: "block", fontSize: 10, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: ".07em", marginBottom: 7 }}>Reason *</label>
                    <textarea autoFocus rows={3} value={note} onChange={e => setNote(e.target.value)} placeholder="Explain why these answers are being rejected…" style={{ width: "100%", resize: "none", fontSize: 13, padding: "9px 12px", borderRadius: 8, lineHeight: 1.55, border: `1.5px solid ${note.trim() ? "#e5e7eb" : "#fca5a5"}`, outline: "none", fontFamily: "var(--aap-font)", color: "#0e1726", background: "#f3f4f6" }} />
                    <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                        <button onClick={() => note.trim() && onConfirm(note)} disabled={!note.trim() || saving} className="btn-reject" style={{ flex: 1, justifyContent: "center", borderRadius: 8 }}>
                            {saving ? <><span className="aap-spin" style={{ borderTopColor: "#dc2626", borderRightColor: "#fecdd3" }} /> Saving…</> : "Confirm Rejection"}
                        </button>
                        <button onClick={onCancel} className="btn-sec">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InlineReject = ({ onConfirm, onCancel, saving }) => {
    const [note, setNote] = useState("");
    return (
        <tr>
            <td colSpan={8} style={{ padding: 0 }}>
                <div className="aap-reject-panel">
                    <div style={{ fontSize: 9.5, fontWeight: 700, color: "#dc2626", textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 8, display: "flex", alignItems: "center", gap: 5, fontFamily: "var(--aap-font)" }}>
                        <span style={{ width: 5, height: 5, borderRadius: "50%", background: "#dc2626", flexShrink: 0 }} />
                        Rejection reason *
                    </div>
                    <textarea autoFocus rows={2} value={note} onChange={e => setNote(e.target.value)} placeholder="Explain why this answer is being rejected…" style={{ width: "100%", maxWidth: 540, resize: "none", fontSize: 12.5, padding: "8px 11px", borderRadius: 7, lineHeight: 1.6, border: "1.5px solid #fca5a5", outline: "none", fontFamily: "var(--aap-font)", color: "#0e1726", background: "#fff", boxSizing: "border-box" }} />
                    <div style={{ display: "flex", gap: 7, marginTop: 9 }}>
                        <button onClick={() => note.trim() && onConfirm(note)} disabled={!note.trim() || saving} className="btn-reject" style={{ fontSize: 11, padding: "5px 14px" }}>
                            {saving ? <><span className="aap-spin" style={{ borderTopColor: "#dc2626", borderRightColor: "#fecdd3" }} /> Saving…</> : "Confirm"}
                        </button>
                        <button onClick={onCancel} className="btn-sec" style={{ fontSize: 11, padding: "5px 12px" }}>Cancel</button>
                    </div>
                </div>
            </td>
        </tr>
    );
};

const ShimmerRow = ({ i }) => (
    <tr style={{ borderBottom: "1px solid #f3f4f6", opacity: 1 - i * .13 }}>
        <td style={{ padding: "14px 12px" }}><div className="aap-shimmer" style={{ width: 14, height: 14, borderRadius: 3 }} /></td>
        {[0, 1, 2, 3, 4, 5].map(j => (
            <td key={j} style={{ padding: "14px 12px" }}>
                <div className="aap-shimmer" style={{ height: 11, width: `${36 + (j * 17) % 44}%` }} />
            </td>
        ))}
        <td />
    </tr>
);

/* ═══════════════════════════════════════════════════════════
   AUDIT ROW
═══════════════════════════════════════════════════════════ */
const AuditRow = ({ row, idx, questionId, fyId, kpiTitle, questionType, onViewDoc, onDone, selected, onToggle, isAdmin }) => {
    const { currentUserId } = useCurrentUser();
    const [showReject, setShowReject] = useState(false);
    const [saving, setSaving] = useState(false);
    const [savingKind, setSavingKind] = useState("");

    const rawStatus = (row.auditStatus || "PENDING").toUpperCase();
    const nameStr = row.submittedByName || `User #${row.submittedBy}`;
    const auditLevels = row.auditLevels || [];

    const myEntry = resolveMyEntry(auditLevels, currentUserId);
    const myStatus = myEntry ? (myEntry.status || "PENDING").toUpperCase() : null;
    const myType = myEntry?.auditorType || "";
    
    /* ── Status badge: Use level status if available, else global ── */
    const displayStatus = useMemo(() => {
        if (isAdmin) return rawStatus;
        return myStatus || rawStatus;
    }, [isAdmin, rawStatus, myStatus]);

    const prevOK = prevLevelsAllApproved(auditLevels, myEntry);
    const iMyPending = myEntry && ["PENDING", "IN_REVIEW"].includes(myStatus);
    // eslint-disable-next-line eqeqeq
    const isCurrent = Number(row.currentAuditorId) == Number(currentUserId);
    const canAct = iMyPending && prevOK && isCurrent;
    const alreadyActed = myEntry && ["APPROVED", "ACCEPTED", "REJECTED"].includes(myStatus) && !["PENDING", "IN_REVIEW"].includes(myStatus);
    const waitingPrev = iMyPending && !prevOK;

    const blockingLevel = waitingPrev
        ? auditLevels.filter(l => {
            const mt = (myEntry?.auditorType || "").toUpperCase();
            if (mt === "EXTERNAL") return (((l.auditorType || "").toUpperCase() === "INTERNAL" || ((l.auditorType || "").toUpperCase() === "EXTERNAL" && l.auditLevel < myEntry.auditLevel)) && !["APPROVED", "ACCEPTED"].includes((l.status || "").toUpperCase()));
            return (l.auditorType || "").toUpperCase() === "INTERNAL" && l.auditLevel < myEntry.auditLevel && !["APPROVED", "ACCEPTED"].includes((l.status || "").toUpperCase());
          }).sort((a, b) => { const ord = t => (t || "").toUpperCase() === "INTERNAL" ? 0 : 1; return ord(a.auditorType) !== ord(b.auditorType) ? ord(a.auditorType) - ord(b.auditorType) : a.auditLevel - b.auditLevel; })[0]
        : null;

    const isEven = idx % 2 === 0;
    
    /* ── Color Logic: Based on displayStatus (the auditor's specific level) ── */
    const statusKey = ["APPROVED", "ACCEPTED"].includes(displayStatus) ? "approved" : displayStatus === "REJECTED" ? "rejected" : displayStatus === "IN_REVIEW" ? "inreview" : "pending";
    const rowCls = `aap-tr aap-tr-${isEven ? "even" : "odd"}-${statusKey}`;
    const accentClr = ["APPROVED", "ACCEPTED"].includes(displayStatus) ? "#0d9488" : displayStatus === "REJECTED" ? "#dc2626" : displayStatus === "IN_REVIEW" ? "#2563eb" : "#d97706";

    const submit = async (action, remark = "") => {
        setSaving(true); setSavingKind(action);
        try {
            await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}auditAction`, {}, { questionId: Number(questionId), answerId: row.answerId, stepIds: [row.id], financialYearId: Number(fyId), action, remark, questionType, questionTitle: kpiTitle }, "POST");
            setShowReject(false);
            onDone?.();
        } finally { setSaving(false); setSavingKind(""); }
    };

    return (
        <>
            <tr className={rowCls}>
                <td style={{ width: 48, padding: "0 6px 0 0", textAlign: "center", verticalAlign: "middle", position: "relative" }}>
                    <div style={{ position: "absolute", left: 0, top: 6, bottom: 6, width: 3, borderRadius: "0 3px 3px 0", background: accentClr }} />
                    {canAct
                        ? <input type="checkbox" className="aap-cb" checked={selected} onChange={() => onToggle(row.id)} />
                        : <span style={{ fontSize: 10, color: "var(--aap-ink4)", fontFamily: "var(--aap-mono)" }}>{idx + 1}</span>
                    }
                </td>

                <td style={{ padding: "13px 12px" }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "var(--aap-ink)", fontFamily: "var(--aap-mono)", lineHeight: 1.4, whiteSpace: "nowrap" }}>
                        {fmtDate(row.fromDate)}
                        {row.toDate && row.toDate !== row.fromDate && <span style={{ color: "var(--aap-ink4)", fontWeight: 400 }}> – {fmtDate(row.toDate)}</span>}
                    </div>
                    {row.textValue && <div style={{ fontSize: 10.5, color: "var(--aap-ink4)", marginTop: 2, maxWidth: 190, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontFamily: "var(--aap-font)" }}>{row.textValue}</div>}
                </td>

                <td style={{ padding: "13px 12px", width: 96 }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "var(--aap-ink)", fontFamily: "var(--aap-mono)", lineHeight: 1 }}>{row.value ?? "—"}</div>
                    {row.unit && row.unit !== "-" && <div style={{ fontSize: 9.5, color: "var(--aap-ink4)", marginTop: 2, fontFamily: "var(--aap-mono)" }}>{row.unit}</div>}
                </td>

                <td style={{ padding: "13px 12px", width: 162 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Avatar name={nameStr} id={row.submittedBy} />
                        <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--aap-ink2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 108, fontFamily: "var(--aap-font)" }}>{nameStr}</div>
                            <div style={{ fontSize: 10, color: "var(--aap-ink4)", fontFamily: "var(--aap-mono)", marginTop: 1 }}>{fmtDate(row.submittedDate)}</div>
                        </div>
                    </div>
                </td>

                <td style={{ padding: "13px 12px", width: 78, textAlign: "center" }}>
                    {row.document?.documentMetadata?.url ? (
                        <button onClick={() => { const m = row.document.documentMetadata; onViewDoc({ url: m.url, name: m.fileName || "File", mimeType: m.mimeType || "", isImage: /image\//i.test(m.mimeType || "") }); }} style={{ padding: "4px 10px", borderRadius: 6, border: "1.5px solid var(--aap-blue3)", background: "var(--aap-blue2)", color: "var(--aap-blue)", fontSize: 10.5, fontWeight: 700, cursor: "pointer", fontFamily: "var(--aap-font)" }}>View</button>
                    ) : <span style={{ fontSize: 11, color: "var(--aap-line)" }}>—</span>}
                </td>

                <td style={{ padding: "13px 12px", width: 130, textAlign: "center" }}>
                    <Badge status={displayStatus} />
                    {!isAdmin && displayStatus !== rawStatus && (
                        <div style={{ marginTop: 4 }}>
                            <span style={{ fontSize: 9, color: "var(--aap-ink4)", fontFamily: "var(--aap-font)" }}>Global: </span>
                            <Badge status={rawStatus} />
                        </div>
                    )}
                    {row.remark && !["PENDING", "IN_REVIEW"].includes(displayStatus) && (
                        <div title={row.remark} style={{ fontSize: 9.5, color: displayStatus === "REJECTED" ? "var(--aap-red)" : "var(--aap-teal)", marginTop: 4, maxWidth: 100, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: "4px auto 0", fontFamily: "var(--aap-font)" }}>{row.remark}</div>
                    )}
                </td>

                <td style={{ padding: "13px 14px", width: 240, verticalAlign: "top" }}>
                    {canAct && !showReject && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <div style={{ display: "flex", gap: 7, alignItems: "center" }}>
                                <button className="btn-approve" onClick={() => submit("ACCEPTED")} disabled={saving}>
                                    {saving && savingKind === "ACCEPTED" ? <span className="aap-spin" style={{ borderTopColor: "#fff", borderRightColor: "rgba(255,255,255,.3)" }} /> : <span style={{ fontSize: 13, lineHeight: 1 }}>✓</span>}
                                    Approve
                                </button>
                                <button className="btn-reject" onClick={() => setShowReject(true)} disabled={saving}>
                                    <span style={{ fontSize: 13, lineHeight: 1 }}>✕</span> Reject
                                </button>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                <TypeBadge type={myType} />
                                <span style={{ fontSize: 9.5, color: "var(--aap-ink4)", fontFamily: "var(--aap-font)" }}>Level {myEntry?.auditLevel} auditor</span>
                            </div>
                            <AuditChainFlow auditLevels={auditLevels} />
                        </div>
                    )}

                    {alreadyActed && !showReject && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                            <span className="aap-action-chip" style={{ background: myStatus === "REJECTED" ? "linear-gradient(135deg,#fff1f2,#ffe4e6)" : "linear-gradient(135deg,#f0fdfa,#d1fae5)", border: `1.5px solid ${myStatus === "REJECTED" ? "#fecdd3" : "#99f6e4"}`, color: myStatus === "REJECTED" ? "#dc2626" : "#0d9488" }}>
                                <span style={{ width: 18, height: 18, borderRadius: "50%", background: myStatus === "REJECTED" ? "#dc2626" : "#0d9488", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 800, flexShrink: 0 }}>
                                    {myStatus === "REJECTED" ? "✕" : "✓"}
                                </span>
                                {myStatus === "REJECTED" ? "Rejected by you" : "Approved by you"}
                            </span>
                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                <TypeBadge type={myType} />
                                <span style={{ fontSize: 9.5, color: "var(--aap-ink4)", fontFamily: "var(--aap-font)" }}>Level {myEntry?.auditLevel}</span>
                            </div>
                            <AuditChainFlow auditLevels={auditLevels} />
                        </div>
                    )}

                    {waitingPrev && !showReject && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                            <span className="aap-await-chip">
                                <span className="aap-spin" style={{ borderTopColor: "var(--aap-ink3)", borderRightColor: "var(--aap-line)" }} />
                                Awaiting Level {blockingLevel?.auditLevel}
                                {blockingLevel?.auditorType && <TypeBadge type={blockingLevel.auditorType} />}
                            </span>
                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                <TypeBadge type={myType} />
                                <span style={{ fontSize: 9.5, color: "var(--aap-ink4)", fontFamily: "var(--aap-font)" }}>You're Level {myEntry?.auditLevel}</span>
                            </div>
                            <AuditChainFlow auditLevels={auditLevels} />
                        </div>
                    )}

                    {!myEntry && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                            {isAdmin && row.currentAuditorName && (
                                <span style={{ fontSize: 10.5, color: "var(--aap-ink3)", fontFamily: "var(--aap-font)", display: "flex", alignItems: "center", gap: 4 }}>
                                    <span style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--aap-gold)", flexShrink: 0 }} />
                                    {row.currentAuditorName}
                                </span>
                            )}
                            {!isAdmin && <span className="aap-na-chip">Not in your queue</span>}
                            <AuditChainFlow auditLevels={auditLevels} />
                        </div>
                    )}
                </td>

                <td style={{ width: 6 }} />
            </tr>

            {showReject && (
                <InlineReject saving={saving && savingKind === "REJECTED"} onConfirm={note => submit("REJECTED", note)} onCancel={() => setShowReject(false)} />
            )}
        </>
    );
};

/* ═══════════════════════════════════════════════════════════
   MAIN PAGE
═══════════════════════════════════════════════════════════ */
const AuditAnswerPage = (props) => {
    const router = useHistory();
    const routerLoc = useRouterLocation();
    const { currentUserId } = useCurrentUser();

    const isAdmin = Number(currentUserId) === 1;

    const navState = (() => {
        if (routerLoc.state?.questionId) {
            try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(routerLoc.state)); } catch { }
            return routerLoc.state;
        }
        try { const s = sessionStorage.getItem(SESSION_KEY); if (s) return JSON.parse(s); } catch { }
        const p = new URLSearchParams(routerLoc.search);
        return { questionId: p.get("questionId"), fyId: p.get("fyId"), locationIds: p.get("locationId"), title: p.get("title") || "KPI Review", module: p.get("module") || "", unit: p.get("unit") || "", questionType: p.get("questionType") || "", auditType: p.get("auditType") || "" };
    })();

    const { questionId, fyId: fyIdParam, locationIds: locationId, title: kpiTitle = "KPI Review", module: kpiModule = "", unit = "", questionType = "", auditType = "" } = navState;

    useEffect(() => { injectStyles(); }, []);

    const [sidebarExpanded, setSidebarExpanded] = useState(true);
    const [rows, setRows] = useState([]);
    const [fys, setFys] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [fyId, setFyId] = useState(fyIdParam || "");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [statusFilter, setStatusFilter] = useState("PENDING");
    const [userFilter, setUserFilter] = useState("");
    const [selected, setSelected] = useState(new Set());
    const [bulkRejectOpen, setBulkRejectOpen] = useState(false);
    const [bulkSaving, setBulkSaving] = useState(false);
    const [approvingAll, setApprovingAll] = useState(false);
    const [docModal, setDocModal] = useState(null);
    const [toast, setToast] = useState(null);

    const notify = (msg, type = "ok") => { setToast({ msg, type }); setTimeout(() => setToast(null), 3500); };

    useEffect(() => {
        apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getFinancialYear`, {}, {}, "GET")
            .then(res => { const list = res?.data?.data || []; setFys(list); if (!fyId && list.length) setFyId(String(list[list.length - 1].id)); })
            .catch(() => { });
    }, []);

    const load = useCallback(async (overrideFy) => {
        if (!questionId) { setError("No question ID."); setLoading(false); return; }
        const useFy = overrideFy ?? fyId;
        if (!useFy) return;
        setLoading(true); setError(null); setSelected(new Set());
        try {
            const qp = { questionId, financialYearId: useFy };
            if (locationId) qp.locationId = locationId;
            if (auditType) qp.auditorType = auditType;
            const res = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getAuditAnswers`, {}, qp, "GET");
            const data = res?.data?.data || res?.data || [];
            setRows(Array.isArray(data) ? data : []);
        } catch { setError("Failed to load answers."); }
        finally { setLoading(false); }
    }, [questionId, fyId, locationId, auditType]);

    const prevFy = useRef("");
    useEffect(() => { if (fyId && fyId !== prevFy.current) { prevFy.current = fyId; load(fyId); } }, [fyId, load]);

    const userOptions = useMemo(() => {
        const seen = new Map();
        for (const r of rows) {
            const id = String(r.submittedBy ?? "");
            const name = r.submittedByName || `User #${r.submittedBy}`;
            if (id && !seen.has(id)) seen.set(id, { id, name });
        }
        return [...seen.values()].sort((a, b) => a.name.localeCompare(b.name));
    }, [rows]);

    const displayed = rows.filter(r => {
        if (statusFilter) {
            const myEntry = resolveMyEntry(r.auditLevels || [], currentUserId);
            const myStatus = myEntry ? (myEntry.status || "PENDING").toUpperCase() : null;
            
            /* Admin filters by global, Auditor filters by their own level decision */
            const statusToFilter = isAdmin ? (r.auditStatus || "PENDING").toUpperCase() : (myStatus || (r.auditStatus || "PENDING").toUpperCase());
            
            const f = statusFilter.toUpperCase();
            if (f === "APPROVED" && !["ACCEPTED", "APPROVED"].includes(statusToFilter)) return false;
            if (f !== "APPROVED" && statusToFilter !== f) return false;
        }
        const rowStart = r.fromDate ? new Date(r.fromDate) : null;
        const rowEnd = r.toDate ? new Date(r.toDate) : rowStart;
        if (fromDate && rowEnd && rowEnd < new Date(fromDate)) return false;
        if (toDate && rowStart && rowStart > new Date(toDate)) return false;
        if (userFilter && String(r.submittedBy) !== userFilter) return false;
        return true;
    });

    const pendingRows = rows.filter(r => ["PENDING", "IN_REVIEW"].includes(r.auditStatus || "PENDING"));
    const approvedRows = rows.filter(r => ["ACCEPTED", "APPROVED"].includes(r.auditStatus));
    const rejectedRows = rows.filter(r => r.auditStatus === "REJECTED");
    const hasFilters = !!(fromDate || toDate || statusFilter !== "PENDING" || userFilter);

    const actionable = displayed.filter(r => {
        const lvls = r.auditLevels || [];
        const myEntry = resolveMyEntry(lvls, currentUserId);
        if (!myEntry) return false;
        if (!["PENDING", "IN_REVIEW"].includes((myEntry.status || "PENDING").toUpperCase())) return false;
        // eslint-disable-next-line eqeqeq
        if (Number(r.currentAuditorId) != Number(currentUserId)) return false;
        return prevLevelsAllApproved(lvls, myEntry);
    });

    const allSel = actionable.length > 0 && actionable.every(r => selected.has(r.id));
    const someSel = actionable.some(r => selected.has(r.id));
    const toggleRow = id => setSelected(p => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; });
    const toggleAll = () => allSel ? setSelected(new Set()) : setSelected(new Set(actionable.map(r => r.id)));
    const clearFilters = () => { setFromDate(""); setToDate(""); setStatusFilter("PENDING"); setUserFilter(""); };

    const approveAll = async () => {
        if (!actionable.length) return;
        setApprovingAll(true);
        try {
            await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}auditAction`, {}, { questionId: Number(questionId), stepIds: actionable.map(r => r.id), financialYearId: Number(fyId), action: "ACCEPTED", remark: "", questionType, questionTitle: kpiTitle }, "POST");
            await load(); notify(`${actionable.length} answer${actionable.length > 1 ? "s" : ""} approved`);
        } catch { notify("Failed to approve all", "error"); }
        finally { setApprovingAll(false); }
    };

    const bulkApprove = async () => {
        const ids = [...selected]; if (!ids.length) return;
        setBulkSaving(true);
        try {
            await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}auditAction`, {}, { questionId: Number(questionId), stepIds: ids, financialYearId: Number(fyId), action: "ACCEPTED", remark: "", questionType, questionTitle: kpiTitle }, "POST");
            await load(); notify(`${ids.length} answer${ids.length > 1 ? "s" : ""} approved`);
        } catch { notify("Failed to approve", "error"); }
        finally { setBulkSaving(false); }
    };

    const bulkReject = async (remark) => {
        const ids = [...selected]; if (!ids.length) return;
        setBulkSaving(true);
        try {
            await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}auditAction`, {}, { questionId: Number(questionId), stepIds: ids, financialYearId: Number(fyId), action: "REJECTED", remark, questionType, questionTitle: kpiTitle }, "POST");
            setBulkRejectOpen(false); await load(); notify(`${ids.length} answer${ids.length > 1 ? "s" : ""} rejected`);
        } catch { notify("Failed to reject", "error"); }
        finally { setBulkSaving(false); }
    };

    const TH = ({ children, center, w }) => (
        <th style={{ padding: "10px 12px", fontSize: 9.5, fontWeight: 700, color: "var(--aap-ink4)", textTransform: "uppercase", letterSpacing: ".09em", textAlign: center ? "center" : "left", width: w, whiteSpace: "nowrap", fontFamily: "var(--aap-font)" }}>
            {children}
        </th>
    );

    return (
        <div className="aap-wrap" style={{ display: "flex", background: "var(--aap-bg)", minHeight: "100vh" }}>

            <div style={{ flex: sidebarExpanded ? "0 0 21%" : "0 0 60px", position: "sticky", top: 0, height: "100vh", background: "#fff", borderRight: "1px solid var(--aap-line)", zIndex: 100, transition: "flex .2s" }}>
                <Sidebar dataFromParent={props.location?.pathname || "/dashboard"} onSidebarToggle={setSidebarExpanded} />
            </div>

            <main style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
                <Header />

                <div style={{ background: "#fff", borderBottom: "1px solid var(--aap-line)", padding: "16px 26px 0", flexShrink: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12, fontSize: 12, fontFamily: "var(--aap-font)" }}>
                        <button onClick={() => router.goBack()} style={{ border: "none", background: "none", cursor: "pointer", fontSize: 12, color: "var(--aap-ink4)", padding: 0, fontFamily: "var(--aap-font)" }}>← Back</button>
                        <span style={{ color: "var(--aap-line)" }}>/</span>
                        <span style={{ color: "var(--aap-ink2)", fontWeight: 600 }}>Answer Review</span>
                        {auditType && (
                            <span style={{ padding: "1px 8px", borderRadius: 4, fontSize: 10, fontWeight: 700, background: auditType === "INTERNAL" ? "var(--aap-blue2)" : "var(--aap-purple2)", color: auditType === "INTERNAL" ? "var(--aap-blue)" : "var(--aap-purple)", border: `1px solid ${auditType === "INTERNAL" ? "var(--aap-blue3)" : "var(--aap-purple3)"}`, textTransform: "uppercase", letterSpacing: ".05em", fontFamily: "var(--aap-font)" }}>
                                {auditType}
                            </span>
                        )}
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, flexWrap: "wrap", marginBottom: 16 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <h1 style={{ fontSize: 19, fontWeight: 800, color: "var(--aap-ink)", margin: "0 0 7px", letterSpacing: "-.02em", lineHeight: 1.3, wordBreak: "break-word", fontFamily: "var(--aap-font)" }}>
                                {loading ? <div className="aap-shimmer" style={{ height: 22, width: 280, display: "inline-block" }} /> : kpiTitle}
                            </h1>
                            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                                {kpiModule && (
                                    <span style={{ padding: "2px 9px", borderRadius: 5, background: "var(--aap-blue2)", border: "1px solid var(--aap-blue3)", fontSize: 10, fontWeight: 700, color: "var(--aap-blue)", textTransform: "uppercase", letterSpacing: ".05em", fontFamily: "var(--aap-font)" }}>{kpiModule}</span>
                                )}
                                {isAdmin && <span style={{ padding: "2px 9px", borderRadius: 5, background: "var(--aap-gold2)", border: "1px solid var(--aap-gold3)", fontSize: 10, fontWeight: 700, color: "var(--aap-gold)", fontFamily: "var(--aap-font)" }}>Admin View</span>}
                            </div>
                        </div>

                        {!loading && !error && (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 10, flexShrink: 0 }}>
                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
                                    <Stat label="Total" value={rows.length} color="var(--aap-blue)" bg="var(--aap-blue2)" border="var(--aap-blue3)" />
                                    <Stat label="Pending" value={pendingRows.length} color="var(--aap-gold)" bg="var(--aap-gold2)" border="var(--aap-gold3)" />
                                    <Stat label="Approved" value={approvedRows.length} color="var(--aap-teal)" bg="var(--aap-teal2)" border="var(--aap-teal3)" />
                                    {rejectedRows.length > 0 && <Stat label="Rejected" value={rejectedRows.length} color="var(--aap-red)" bg="var(--aap-red2)" border="var(--aap-red3)" />}
                                </div>
                                {actionable.length > 0 && (
                                    <button className="btn-approve-all" onClick={approveAll} disabled={approvingAll}>
                                        {approvingAll ? <><span className="aap-spin" style={{ borderTopColor: "#fff", borderRightColor: "rgba(255,255,255,.3)" }} /> Approving…</> : <><span style={{ fontSize: 14 }}>✓</span> Approve All Pending ({actionable.length})</>}
                                    </button>
                                )}
                            </div>
                        )}
                    </div>

                    <FilterBar
                        fromDate={fromDate} onFromDate={setFromDate}
                        toDate={toDate} onToDate={setToDate}
                        fyId={fyId} onFyId={setFyId}
                        statusFilter={statusFilter} onStatusFilter={setStatusFilter}
                        userFilter={userFilter} onUserFilter={setUserFilter}
                        fys={fys} userOptions={userOptions}
                        hasFilters={hasFilters} onClear={clearFilters}
                        displayedCount={displayed.length} totalCount={rows.length}
                        loading={loading}
                    />
                </div>

                {someSel && (
                    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 24px", background: "var(--aap-blue2)", borderBottom: "1.5px solid var(--aap-blue3)", flexShrink: 0 }}>
                        <span style={{ width: 7, height: 7, borderRadius: "50%", background: "var(--aap-blue)", flexShrink: 0 }} />
                        <span style={{ fontSize: 12.5, fontWeight: 700, color: "var(--aap-blue)", fontFamily: "var(--aap-font)" }}>{selected.size} row{selected.size > 1 ? "s" : ""} selected</span>
                        <div style={{ width: 1, height: 16, background: "var(--aap-blue3)" }} />
                        <button className="btn-bulk-ok" onClick={bulkApprove} disabled={bulkSaving}>✓ Approve Selected</button>
                        <button className="btn-reject" onClick={() => setBulkRejectOpen(true)} disabled={bulkSaving} style={{ fontSize: 11, padding: "5px 13px" }}>✕ Reject Selected</button>
                        <button className="btn-sec" onClick={() => setSelected(new Set())} style={{ fontSize: 11, padding: "5px 12px" }}>Deselect</button>
                    </div>
                )}

                {toast && (
                    <div className="aap-toast" style={{ padding: "10px 24px", display: "flex", alignItems: "center", gap: 8, fontSize: 12.5, fontWeight: 600, color: toast.type === "error" ? "var(--aap-red)" : "var(--aap-teal)", background: toast.type === "error" ? "var(--aap-red2)" : "var(--aap-teal2)", borderBottom: `1.5px solid ${toast.type === "error" ? "var(--aap-red3)" : "var(--aap-teal3)"}`, flexShrink: 0, fontFamily: "var(--aap-font)" }}>
                        <span style={{ width: 7, height: 7, borderRadius: "50%", background: toast.type === "error" ? "var(--aap-red)" : "var(--aap-teal)", flexShrink: 0 }} />
                        {toast.msg}
                    </div>
                )}

                <div style={{ flex: 1, overflow: "auto", padding: "16px 24px 48px" }}>
                    <div style={{ background: "#fff", borderRadius: 14, border: "1px solid var(--aap-line)", overflow: "hidden", boxShadow: "0 2px 6px rgba(0,0,0,.04),0 8px 28px rgba(0,0,0,.06)" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <colgroup>
                                <col style={{ width: 48 }} /><col />
                                <col style={{ width: 96 }} /><col style={{ width: 162 }} />
                                <col style={{ width: 78 }} /><col style={{ width: 130 }} />
                                <col style={{ width: 240 }} /><col style={{ width: 6 }} />
                            </colgroup>
                            <thead>
                                <tr style={{ background: "linear-gradient(to bottom,#f5f7fb,#eef0f6)", borderBottom: "2px solid var(--aap-line)" }}>
                                    <th style={{ width: 48, padding: "10px 8px 10px 16px", textAlign: "center" }}>
                                        {actionable.length > 0 && <input type="checkbox" className="aap-cb" checked={allSel} ref={el => { if (el) el.indeterminate = someSel && !allSel; }} onChange={toggleAll} />}
                                    </th>
                                    <TH>Period</TH>
                                    <TH>Value</TH>
                                    <TH>Submitted By</TH>
                                    <TH center>Doc</TH>
                                    <TH center>Status</TH>
                                    <TH>Action</TH>
                                    <th style={{ width: 6 }} />
                                </tr>
                            </thead>
                            <tbody>
                                {loading && [0, 1, 2, 3, 4].map(i => <ShimmerRow key={i} i={i} />)}

                                {!loading && error && (
                                    <tr><td colSpan={8} style={{ padding: "60px 24px", textAlign: "center", fontFamily: "var(--aap-font)" }}>
                                        <div style={{ fontWeight: 700, color: "var(--aap-red)", marginBottom: 6 }}>Failed to load</div>
                                        <div style={{ fontSize: 12, color: "var(--aap-ink4)", marginBottom: 14 }}>{error}</div>
                                        <button className="btn-sec" onClick={() => load()}>Retry</button>
                                    </td></tr>
                                )}

                                {!loading && !error && displayed.length === 0 && (
                                    <tr><td colSpan={8} style={{ padding: "72px 24px", textAlign: "center", fontFamily: "var(--aap-font)" }}>
                                        <div style={{ fontSize: 30, marginBottom: 10, opacity: .2 }}>{rows.length === 0 ? "📋" : "🔍"}</div>
                                        <div style={{ fontWeight: 700, fontSize: 14, color: "var(--aap-ink2)", marginBottom: 5 }}>
                                            {rows.length === 0 ? "No answers to review" : "No records match filters"}
                                        </div>
                                        <div style={{ fontSize: 12, color: "var(--aap-ink4)" }}>
                                            {rows.length === 0 ? "No answers submitted yet." : "Try adjusting the date, status, or user filter."}
                                        </div>
                                        {hasFilters && <button className="btn-sec" style={{ marginTop: 14 }} onClick={clearFilters}>Clear filters</button>}
                                    </td></tr>
                                )}

                                {!loading && !error && displayed.map((row, i) => (
                                    <AuditRow
                                        key={row.id || i} row={row} idx={i}
                                        questionId={questionId} fyId={fyId}
                                        kpiTitle={kpiTitle} questionType={questionType}
                                        onViewDoc={info => setDocModal(info)}
                                        onDone={() => { notify("Saved"); load(); }}
                                        selected={selected.has(row.id)}
                                        onToggle={toggleRow}
                                        isAdmin={isAdmin}
                                    />
                                ))}
                            </tbody>
                        </table>

                        {loading && (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: 14, color: "var(--aap-ink4)", fontSize: 12, borderTop: "1px solid var(--aap-line2)", fontFamily: "var(--aap-font)" }}>
                                <span className="aap-spin" style={{ borderTopColor: "var(--aap-blue)", borderRightColor: "var(--aap-blue3)" }} /> Loading…
                            </div>
                        )}

                        {!loading && !error && displayed.length > 0 && (
                            <div style={{ padding: "9px 20px", borderTop: "1px solid var(--aap-line2)", background: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
                                <span style={{ fontSize: 11, color: "var(--aap-ink4)", fontFamily: "var(--aap-mono)" }}>
                                    {displayed.length} record{displayed.length !== 1 ? "s" : ""}{hasFilters ? ` (filtered from ${rows.length})` : ""}
                                </span>
                                <div style={{ display: "flex", gap: 14 }}>
                                    {[["Approved", "var(--aap-teal)", approvedRows.length], ["Pending", "var(--aap-gold)", pendingRows.length], ["Rejected", "var(--aap-red)", rejectedRows.length]]
                                        .filter(([, , v]) => v > 0)
                                        .map(([l, c, v]) => (
                                            <span key={l} style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 11, fontWeight: 700, color: c, fontFamily: "var(--aap-font)" }}>
                                                <span style={{ width: 5, height: 5, borderRadius: "50%", background: c }} />{v} {l}
                                            </span>
                                        ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </main>

            {docModal && <DocModal info={docModal} onClose={() => setDocModal(null)} />}
            {bulkRejectOpen && <BulkRejectModal count={selected.size} saving={bulkSaving} onConfirm={bulkReject} onCancel={() => setBulkRejectOpen(false)} />}
        </div>
    );
};

export default AuditAnswerPage;